import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as organization from '../../../../organization'
import * as stakeholder from '../stakeholder'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: stakeholder.RESOURCE.payload.dimension.partialId,
      partialId: stakeholder.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Sub-department or team the stakeholder belongs to.',
    isOptional: true,
    name: 'Subdepartment',
    partialId: PartialId.Standard.create('subdepartment'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        organization.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
